/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import style from './pagination.module.scss';
import Pagination from '@mui/material/Pagination';
import arrowRight from 'icons/arrowRight';
import arrowLeft from 'icons/arrowLeft';
import { PaginationItem } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import cx from 'classnames';
import { MIN_TABLET_WIDTH } from 'utils/utils';
import { useViewport } from 'contexts/viewportContext';

export default function PaginationComponent({
  className,
  total = 10,
}: {
  className?: string;
  total?: number;
}) {
  const { width } = useViewport();
  const [searchParams] = useSearchParams();
  const urlPageNumber = Number(searchParams.get('page')) || 1;
  const [page, setPage] = useState(urlPageNumber);
  const navigate = useNavigate();
  // const isMobileAdaptiveModeOn = window.innerWidth < MIN_TABLET_WIDTH;
  const isMobileAdaptiveModeOn = width <= MIN_TABLET_WIDTH;

  useEffect(() => {
    setPage(urlPageNumber);
  }, [urlPageNumber]);

  return (
    <>
      {total > 1 ? (
        <Pagination
          color="secondary"
          siblingCount={isMobileAdaptiveModeOn ? 0 : 1}
          className={cx(style.container, className)}
          count={total}
          variant="outlined"
          shape="rounded"
          size="large"
          page={page}
          onChange={(e, number) => {
            const currentUrlParams = new URLSearchParams(
              window.location.search
            );
            currentUrlParams.set('page', String(number));

            navigate(
              `${window.location.pathname}?${currentUrlParams.toString()}`,
              {
                replace: false,
              }
            );
          }}
          renderItem={(item) => (
            <PaginationItem
              components={{ previous: arrowLeft, next: arrowRight }}
              {...item}
            />
          )}
        />
      ) : (
        ''
      )}
    </>
  );
}
